export default "__VITE_ASSET__BaNB7Q66__"